import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { iHttpPaginatedResponse } from '../interfaces/iHttpPaginatedResponse';

@Injectable({
  providedIn: 'root'
})
export class TagsService {

  constructor(
    private _http:HttpClient
  ) { }

  public getPaginatedTags(page, pp, filters): Observable<iHttpPaginatedResponse> {
    return this._http.get<iHttpPaginatedResponse>(environment.apiEndpoint + `/api/admin/tags?page=${page}&pp=${pp}&${filters}`).pipe(
        map(res => {
            return res;
        })
    );
  }

  public getTag(id:number): Observable<any>{
    return this._http.get(environment.apiEndpoint + '/api/admin/tag/'+id).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public createNewTag(tag:any): Observable<any>{
    return this._http.post(environment.apiEndpoint + '/api/admin/tags', {tag:tag}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public updateTag(tag:any): Observable<any>{
    return this._http.put(environment.apiEndpoint + '/api/admin/tags/' + tag.id, {tag:tag.tag}).pipe(
      map(
        res=> {
          return res;
        }
      )
    );
  }
}
